import { Box, Typography } from "@mui/material";
import ScrollReveal from "./ScrollReveal";

export default function PageHero({
    title,
    subtitle,
    icon,
    actions,
    children,
    className = "",
    size = "default",
}) {
    const isLarge = size === "large";

    return (
        <ScrollReveal direction="down">
            <Box
                className={`page-hero ${isLarge ? "page-hero--large" : ""} ${className}`}
                sx={{ mb: 3 }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        width: isLarge ? 200 : 140,
                        height: isLarge ? 200 : 140,
                        borderRadius: "50%",
                        background: "rgba(255,255,255,0.06)",
                        bottom: isLarge ? -70 : -50,
                        insetInlineStart: isLarge ? -40 : -30,
                        animation: "homeFloat 6s ease-in-out infinite 0.5s",
                        pointerEvents: "none",
                    }}
                />
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        gap: isLarge ? 3 : 2,
                        minHeight: isLarge ? { xs: 140, md: 160 } : undefined,
                    }}
                >
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                            variant={isLarge ? "h4" : "h5"}
                            fontWeight={800}
                            sx={{
                                lineHeight: 1.25,
                                fontSize: isLarge ? { xs: "1.5rem", sm: "1.75rem", md: "2rem" } : undefined,
                            }}
                        >
                            {title}
                        </Typography>
                        {subtitle ? (
                            <Typography
                                variant={isLarge ? "body1" : "body2"}
                                sx={{
                                    opacity: 0.92,
                                    mt: isLarge ? 1 : 0.5,
                                    lineHeight: 1.7,
                                    fontSize: isLarge ? { xs: "1rem", md: "1.125rem" } : undefined,
                                }}
                            >
                                {subtitle}
                            </Typography>
                        ) : null}
                        {actions ? (
                            <Box sx={{ mt: isLarge ? 2 : 1.5, display: "flex", flexWrap: "wrap", gap: 1 }}>
                                {actions}
                            </Box>
                        ) : null}
                        {children}
                    </Box>
                    {icon ? (
                        <Box
                            className="edu-float-icon"
                            sx={{
                                position: "relative",
                                flexShrink: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "rgba(255,255,255,0.9)",
                                "& svg": { fontSize: isLarge ? { xs: 64, md: 72 } : 56 },
                            }}
                        >
                            {icon}
                        </Box>
                    ) : null}
                </Box>
            </Box>
        </ScrollReveal>
    );
}
